import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useSubscription } from 'features/subscription/useSubscription';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const UserAndRoles = Loadable(lazy(() => import('../pages/users-management')));
const AuditLogs = Loadable(lazy(() => import('../pages/component-overview/audit-logs/audit-logs')));
const CustomerReviews = Loadable(lazy(() => import('../pages/rate-my-business/customer-reviews')));
const CustomerFeedback = Loadable(lazy(() => import('../pages/rate-my-business/customer-feedback')));
const Widgets = Loadable(lazy(() => import('../pages/rate-my-business/widgets')));
const QrCodes = Loadable(lazy(() => import('../pages/rate-my-business/qr-codes')));
const Onboarding = Loadable(lazy(() => import('../pages/onboarding')));
const ClinikoData = Loadable(lazy(() => import('../pages/cliniko-data')));
const Bookings = Loadable(lazy(() => import('../pages/bookings')));
const AutomationWorkflows = Loadable(lazy(() => import('../pages/automation-workflows')));
const SettingsPage = Loadable(lazy(() => import('../pages/settings')));
const BillingPage = Loadable(lazy(() => import('../pages/billing')));
const PlanSelectionPage = Loadable(lazy(() => import('components/PlanSelectionPage')));
// ==============================|| MAIN ROUTING ||============================== //
const SubscriptionGate = () => {
  const { loading } = useSubscription();

  if (loading) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Free-plan users can browse the whole dashboard; premium actions
  // self-gate with upgrade dialogs that lead to /select-plan
  return <DashboardLayout />;
};

const AuthGuard = () => {
  // Auth tokens are in httpOnly cookies (not readable by JS).
  // We check for user info in localStorage as a UI-level auth hint.
  // Actual auth happens via cookies on every API call; if the cookie
  // expires, the refresh interceptor redirects to login.
  const isAuthenticated = !!localStorage.getItem('user');

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  return <SubscriptionGate />;
};

const OnboardingGuard = () => {
  const isAuthenticated = !!localStorage.getItem('user');
  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }
  return <Onboarding />;
};

const PlanSelectionGuard = () => {
  const isAuthenticated = !!localStorage.getItem('user');
  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }
  return <PlanSelectionPage />;
};

const OnboardingRoute = {
  path: '/onboarding',
  element: <OnboardingGuard />
};

const PlanSelectionRoute = {
  path: '/select-plan',
  element: <PlanSelectionGuard />
};

const MainRoutes = {
  path: '/',
  element: <AuthGuard />,
  children: [
    {
      index: true,
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'default',
      element: <DashboardDefault />
    },
    
    {
      path: 'users-management',
      element: <UserAndRoles />
    },
    {
      path: 'audit-logs',
      element: <AuditLogs />
    },
    {
      path: 'rate-my-business/customer-reviews',
      element: <CustomerReviews />
    },
    {
      path: 'rate-my-business/customer-feedback',
      element: <CustomerFeedback />
    },
    {
      path: 'rate-my-business/widgets',
      element: <Widgets />
    },
    {
      path: 'rate-my-business/qr-codes',
      element: <QrCodes />
    },
    {
      path: 'cliniko-data',
      element: <ClinikoData />
    },
    {
      path: 'bookings',
      element: <Bookings />
    },
    {
      path: 'automation-workflows',
      element: <AutomationWorkflows />
    },
    {
      path: 'settings',
      element: <SettingsPage />
    },
    {
      path: 'billing',
      element: <BillingPage />
    },
  ]
};

export { OnboardingRoute, PlanSelectionRoute };
export default MainRoutes;
